export class TheatreActor {
  constructor(actor, navElement) {
    this.actor = actor;
    this.navElement = navElement;
  }
}
